export const SUPPORTED_LOCALES = ['de', 'en', 'fr', 'it'] as const;

export type SupportedLocale = typeof SUPPORTED_LOCALES[number];

export const isSupportedLocale = (
  value: string,
): value is SupportedLocale => SUPPORTED_LOCALES.includes(
  value as SupportedLocale,
);

export const toSupportedLocale = (
  value: string,
) => value as SupportedLocale;
